import { useEffect, useState } from "react";
import * as S from "./styles";

const ButtonToTop = ({ id }: { id: string }) => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);

  const onNavigateToTop = () => {
    const topElement = document.querySelector(`#${id}`);

    if (topElement) {
      topElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const onScroll = () => setScrollPosition(window.scrollY);

    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (scrollPosition < 1000) return null;

  return (
    <S.WrapperButtonToTop onClick={() => onNavigateToTop()}>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" fill="none">
        <path
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="m13.139 1.139-6 6-6-6"
        />
      </svg>
    </S.WrapperButtonToTop>
  );
};

export default ButtonToTop;
